document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.privacy__nav-link');
    const topicSections = document.querySelectorAll('.privacy__topic');
    const accordionToggles = document.querySelectorAll('.privacy__accordion-toggle');
    const accordionContents = document.querySelectorAll('.privacy__accordion-content');

    // Function to check if we're on mobile
    const isMobile = () => window.innerWidth <= 768;

    // Desktop functionality
    if (navLinks.length && topicSections.length) {
        // Function to switch active topic (desktop)
        const switchTopic = (targetId) => {
            // Deactivate all links and sections
            navLinks.forEach(link => link.classList.remove('is-active'));
            topicSections.forEach(section => section.classList.remove('is-active'));

            // Activate the target link and section
            const targetLink = document.querySelector(`.privacy__nav-link[data-target="${targetId}"]`);
            const targetSection = document.querySelector(targetId);

            if (targetLink) {
                targetLink.classList.add('is-active');
            }
            if (targetSection) {
                targetSection.classList.add('is-active');
            }
        };

        // Add click event listeners to nav links (desktop)
        navLinks.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent default anchor behavior

                const targetId = link.getAttribute('data-target');
                if (targetId) {
                    switchTopic(targetId);

                    // Get the target element and scroll to it with offset
                    const targetElement = document.querySelector(targetId);
                    if (targetElement) {
                        const elementPosition = targetElement.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - 200;

                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

    // Mobile accordion functionality
    if (accordionToggles.length && accordionContents.length) {
        // Function to toggle accordion
        const toggleAccordion = (toggle, content) => {
            const isActive = toggle.classList.contains('is-active');

            if (isActive) {
                // Close the accordion
                toggle.classList.remove('is-active');
                toggle.setAttribute('aria-expanded', 'false');
                content.classList.remove('is-active');
            } else {
                // Close all other accordions first (optional - remove if you want multiple open)
                accordionToggles.forEach(otherToggle => {
                    if (otherToggle !== toggle) {
                        otherToggle.classList.remove('is-active');
                        otherToggle.setAttribute('aria-expanded', 'false');
                        const otherTargetId = otherToggle.getAttribute('data-target');
                        const otherContent = document.getElementById(otherTargetId);
                        if (otherContent) {
                            otherContent.classList.remove('is-active');
                        }
                    }
                });

                // Open the clicked accordion
                toggle.classList.add('is-active');
                toggle.setAttribute('aria-expanded', 'true');
                content.classList.add('is-active');
            }
        };

        // Add click event listeners to accordion toggles
        accordionToggles.forEach(toggle => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();

                const targetId = toggle.getAttribute('data-target');
                const content = document.getElementById(targetId);

                if (content) {
                    toggleAccordion(toggle, content);
                }
            });
        });
    }

    // Handle window resize to ensure proper functionality
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Re-initialize if needed based on new screen size
            // This ensures smooth transitions between mobile and desktop
        }, 250);
    });

    // Optional: Handle initial load based on URL hash (desktop only)
    // const initialHash = window.location.hash;
    // if (initialHash && document.querySelector(initialHash) && !isMobile()) {
    //     const switchTopic = (targetId) => {
    //         navLinks.forEach(link => link.classList.remove('is-active'));
    //         topicSections.forEach(section => section.classList.remove('is-active'));
    //         const targetLink = document.querySelector(`.privacy__nav-link[data-target="${targetId}"]`);
    //         const targetSection = document.querySelector(targetId);
    //         if (targetLink) targetLink.classList.add('is-active');
    //         if (targetSection) targetSection.classList.add('is-active');
    //     };
    //     switchTopic(initialHash);
    // }
});
